export const colorBaseTokens = {
  "color.neutral.000": "#FFFFFF",
  "color.neutral.100": "#F3F4F6",
  "color.neutral.300": "#D1D5DB",
  "color.neutral.500": "#6B7280",
  "color.neutral.700": "#1F2937",
  "color.neutral.900": "#111827",
  "color.primary.100": "#EAF4F5",
  "color.primary.300": "#9FC6CA",
  "color.primary.500": "#053238",
  "color.primary.700": "#04272C",
  "color.primary.900": "#021A1D",
  "color.secondary.100": "#E6F7F7",
  "color.secondary.300": "#7FCFCF",
  "color.secondary.500": "#008080",
  "color.secondary.700": "#006666",
  "color.secondary.900": "#004D4D",
  "color.feedback.success.100": "#DCFCE7",
  "color.feedback.success.300": "#86EFAC",
  "color.feedback.success.500": "#22C55E",
  "color.feedback.success.700": "#16A34A",
  "color.feedback.success.900": "#15803D",
  "color.feedback.warning.100": "#FEF9C3",
  "color.feedback.warning.300": "#FDE047",
  "color.feedback.warning.500": "#EAB308",
  "color.feedback.warning.700": "#CA8A04",
  "color.feedback.warning.900": "#A16207",
  "color.feedback.danger.100": "#FEE2E2",
  "color.feedback.danger.300": "#FCA5A5",
  "color.feedback.danger.500": "#EF4444",
  "color.feedback.danger.700": "#DC2626",
  "color.feedback.danger.900": "#B91C1C"
} as const;

type ColorBaseTokenKey = keyof typeof colorBaseTokens;

export type ColorBaseToken = ColorBaseTokenKey;

export const getColorBaseTokenValue = (token: ColorBaseToken): string => colorBaseTokens[token];

/**
 * Injeta os tokens de cor como variáveis CSS no documento
 * Converte "color.primary.100" para "--color-primary-100"
 */
export const injectColorTokensAsCSS = (): void => {
  const root = document.documentElement;
  Object.entries(colorBaseTokens).forEach(([key, value]) => {
    const cssVarName = `--${key.replace(/\./g, '-')}`;
    root.style.setProperty(cssVarName, value);
  });
};
